var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time-serie-chart',{staticClass:"box-height-100",attrs:{"title":"Active sessions","timer":_vm.timer,"xAxis":_vm.xAxis,"data1":_vm.data1,"data2":_vm.data2,"data3":_vm.data3,"view-type":_vm.viewType}})}
var staticRenderFns = []

export { render, staticRenderFns }